import { render, staticRenderFns } from "./TechnologicalInnovationAdd.vue?vue&type=template&id=0780aa76&scoped=true"
import script from "./TechnologicalInnovationAdd.vue?vue&type=script&lang=js"
export * from "./TechnologicalInnovationAdd.vue?vue&type=script&lang=js"
import style0 from "./TechnologicalInnovationAdd.vue?vue&type=style&index=0&id=0780aa76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0780aa76",
  null
  
)

export default component.exports